var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPricingInfoIcon = function SvgPricingInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "nonzero",
    d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16m.5-3.892c0 .251-.224.454-.5.454s-.5-.203-.5-.454V7.392c0-.251.224-.455.5-.455s.5.204.5.455zm-.469-6.483a.781.781 0 1 1 0-1.562.781.781 0 0 1 0 1.562M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14"
  })));
};
export default SvgPricingInfoIcon;